module.exports = __webpack_public_path__ + "static/media/country-field-grass.c0ff8716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/country-field-grass.jpg
// module id = 280
// module chunks = 0